export default [
  {
    path: "/machine-service-signals",
    name: "machine-service-signals",
    component: () =>
      import("@/modules/machine-service-signals/MachineServiceSignals.vue"),
    children: [
      {
        path: "list",
        name: "list-machine-service-signals",
        component: () =>
          import(
            "@/modules/machine-service-signals/pages/MachineServiceSignalsList.vue"
          ),
        meta: { permissions: ["machine-service-signals-show"] }
      },
      {
        path: "show/:id",
        name: "show-machine-service-signals",
        component: () =>
          import(
            "@/modules/machine-service-signals/pages/MachineServiceSignalsShow.vue"
          ),
        meta: { permissions: ["machine-service-signals-show"] }
      }
    ]
  }
];
